import fetchExpresso from 'utility/fetchExpresso';

// ***** QR Codes ***** //

export async function getHostQRCode(hostId) {
    const response = await fetchExpresso(`/apiv2/hosts/${hostId}/qr-code`);

    if (response.status === 200) {
        const file = await response.text();
        return file;
    } else {
        throw new Error();
    }
}

export async function getEventQRCode(eventId) {
    const response = await fetchExpresso(`/apiv2/events/${eventId}/qr-code`);

    if (response.status === 200) {
        const file = await response.text();
        return file;
    } else {
        throw new Error();
    }
}

// ***** Tracking Sources ***** //

export async function getTrackingSources(hostId, eventId) {
    const response = await fetchExpresso(
        `/apiv2/hosts/${hostId}/events/${eventId}/tracking-sources`,
    );

    if (response.status === 200) {
        const { sources } = await response.json();
        return {
            sources: sources.map((r) => ({ id: r.source_id, name: r.source_name })),
            error: null,
        };
    } else {
        return { sources: null, error: 'Failed to get tracking sources' };
    }
}

// ***** Tracking Links ***** //

export async function getTrackingLinks(hostId, eventId) {
    const response = await fetchExpresso(`/apiv2/hosts/${hostId}/events/${eventId}/tracking-links`);

    if (response.status === 200) {
        const { trackingLinks } = await response.json();
        return {
            trackingLinks: trackingLinks.map((r) => ({
                sourceId: r.source_id,
                sourceName: r.source_name,
                slug: r.tracking_slug,
                link: `${process.env.REACT_APP_STORE_URL}/event/${eventId}?fdsrc=${r.tracking_slug}`,
            })),
            error: null,
        };
    } else {
        return { sources: null, error: 'Failed to get tracking links' };
    }
}

export async function createTrackingLink(hostId, eventId, sourceId, sourceName, slug) {
    const response = await fetchExpresso(
        `/apiv2/hosts/${hostId}/events/${eventId}/tracking-links`,
        {
            method: 'POST',
            body: {
                sourceId: sourceId, // Use existing source
                sourceName: sourceName, // Name of new source (one of these values must be provided)
                slug: slug,
            },
        },
    );

    const { code } = await response.json();

    if (response.status === 200) {
        return { code: null, error: null };
    } else {
        return { code: code, error: 'Failed to create tracking link' };
    }
}

export async function updateTrackingLink(hostId, eventId, sourceId, sourceName, slug) {
    const response = await fetchExpresso(
        `/apiv2/hosts/${hostId}/events/${eventId}/tracking-links/${sourceId}`,
        {
            method: 'PUT',
            body: { sourceName: sourceName, slug: slug },
        },
    );

    const { code } = await response.json();

    if (response.status === 200) {
        return { code: null, error: null };
    } else {
        return { code: code, error: 'Failed to create tracking link' };
    }
}

export async function deleteTrackingLink(hostId, eventId, sourceId) {
    const response = await fetchExpresso(
        `/apiv2/hosts/${hostId}/events/${eventId}/tracking-links/${sourceId}`,
        {
            method: 'DELETE',
        },
    );

    if (response.status === 200) {
        return { error: null };
    } else {
        return { error: 'Failed to create tracking link' };
    }
}
